// Popup wyszukiwarki w nawigacji. Otwiera modal z polem i przyciskiem,
// ktory po wyslaniu przenosi na strone wynikow (WordPress `?s=`).

export function initSearch() {
  const modal = document.querySelector("[data-search-modal]");
  const toggle = document.querySelector(".nav__search");
  if (!modal || !toggle) return;

  const input = modal.querySelector("[data-search-input]");
  const closers = modal.querySelectorAll("[data-search-close]");
  let lastFocused = null;

  const open = () => {
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.classList.add("is-search-open");
    toggle.setAttribute("aria-expanded", "true");
    requestAnimationFrame(() => {
      modal.classList.add("is-open");
      input?.focus();
    });
  };

  const close = () => {
    modal.classList.remove("is-open");
    document.body.classList.remove("is-search-open");
    toggle.setAttribute("aria-expanded", "false");

    const finish = () => {
      modal.hidden = true;
      modal.removeEventListener("transitionend", finish);
    };
    modal.addEventListener("transitionend", finish);

    if (lastFocused instanceof HTMLElement) lastFocused.focus();
  };

  toggle.addEventListener("click", open);
  closers.forEach((el) => el.addEventListener("click", close));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) close();
  });
}
